import {LeadFitScore} from 'nutshell-graphql-types';

export const scoreMap: Record<LeadFitScore, string> = {
    [LeadFitScore.UNLIKELY]: 'unlikely',
    [LeadFitScore.POSSIBLE]: 'possible',
    [LeadFitScore.IDEAL]: 'ideal',
    [LeadFitScore.UNKNOWN]: 'unknown',
};
